import { styled } from '@linaria/react'
import ErrorPage from './error-page'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 22;
  width: 100%;
`

const NotFoundPage = () => {
  return (
    <Container className="flx-ctr">
      <ErrorPage type="404" />
    </Container>
  )
}

export default NotFoundPage
